<template>
    <div>
        <kt-form-group v-if="!gateway.has_limit" style="margin-top: 10px;">
            <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" id="has_limit1" name="has_limit"
                       v-model="gateway.has_limit">
                <label class="custom-control-label" for="has_limit1">{{ $t('label.amount_limitation') }}</label>
            </div>
        </kt-form-group>

        <div class="container p-3 pt-5 my-4 border in-border-header" v-if="gateway.has_limit">
            <kt-form-section is_first>
                <div class="section-header" style="right: -5px;">
                    <kt-form-group class="mb-0">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" id="has_limit2" name="has_limit"
                                   v-model="gateway.has_limit">
                            <label class="custom-control-label" for="has_limit2">{{ $t('label.amount_limitation') }}</label>
                        </div>
                    </kt-form-group>
                </div>

                <transition name="fade">
                    <kt-form-group v-if="gateway.has_limit">
                        <kt-form-label>
                            {{ $t('label.limit_amount') }}
                        </kt-form-label>
                        <div class="kt-input-icon kt-input-icon--right">
                    <span class="kt-input-icon__icon kt-input-icon__icon--right">
                        <span>{{ $t('label.rial') }}</span>
                    </span>
                            <kt-form-control
                                    type="text"
                                    dir="ltr"
                                    id="limit_amount"
                                    name="limit_amount"
                                    v-model="gateway.limit_amount"
                            >
                            </kt-form-control>
                        </div>
                    </kt-form-group>
                </transition>

                <transition name="fade">
                    <kt-form-group v-if="gateway.has_limit">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" id="abroad_ips_only"
                                   name="abroad_ips_only" v-model="gateway.abroad_ips_only">
                            <label class="custom-control-label" for="abroad_ips_only">{{
                                $t('label.abroad_ips_only') }}</label>
                        </div>
                    </kt-form-group>
                </transition>
                <transition name="fade">
                    <kt-form-group v-if="gateway.has_limit">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" id="any_payment_limitation"
                                   name="any_payment_limitation" v-model="gateway.any_payment_limitation">
                            <label class="custom-control-label" for="any_payment_limitation">{{
                                $t('label.any_payment_limitation') }}</label>
                        </div>
                    </kt-form-group>
                </transition>
            </kt-form-section>
        </div>

        <kt-form-group>
            <div class="custom-control custom-switch">
                <input
                        type="checkbox"
                        class="custom-control-input"
                        id="server_ip_limitation"
                        name="server_ip_limitation"
                        v-model="gateway.server_ip_limitation"
                >
                <label class="custom-control-label" for="server_ip_limitation">{{
                    $t('label.server_ip_limitation') }}</label>
            </div>
        </kt-form-group>
        <kt-form-group>
            <div class="custom-control custom-switch">
                <input
                        type="checkbox"
                        class="custom-control-input"
                        id="callback_address_limitation"
                        name="callback_address_limitation"
                        v-model="gateway.callback_address_limitation"
                >
                <label class="custom-control-label" for="callback_address_limitation">{{
                    $t('label.callback_address_limitation') }}</label>
            </div>
        </kt-form-group>
        <kt-form-group>
            <div class="custom-control custom-switch">
                <input
                        type="checkbox"
                        class="custom-control-input"
                        id="referer_limitation"
                        name="referer_limitation"
                        v-model="gateway.referer_limitation"
                >
                <label class="custom-control-label" for="referer_limitation">{{
                    $t('label.referer_limitation') }}</label>
            </div>
        </kt-form-group>
        <kt-form-group>
            <div class="custom-control custom-switch">
                <input
                    type="checkbox"
                    class="custom-control-input"
                    id="callback_limitation_only_by_vpn"
                    name="callback_limitation_only_by_vpn"
                    v-model="gateway.callback_limitation_only_by_vpn"
                >
                <label class="custom-control-label" for="callback_limitation_only_by_vpn">{{
                        $t('label.callback_limitation_by_vpn') }}</label>
            </div>
        </kt-form-group>
    </div>
</template>

<script>

    export default {
        props: {
            gateway: {
                required: true,
            }
        },
    }
</script>
